import React, { ReactNode } from 'react';
import { styled } from '@cp/ds/src/theme/styled';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import DesktopPlaceholderUrl from '../../../assets/shapes/catalogMapPlaceholder.svg?url';
import MobilePlaceholderUrl from '../../../assets/shapes/catalogMapPlaceholderMobile.svg?url';

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundImage: `url(${MobilePlaceholderUrl})`,
  backgroundPosition: 'center center',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    backgroundImage: `url(${DesktopPlaceholderUrl})`,
  },
}));

export interface MapPlaceholderProps extends BoxProps {
  children?: ReactNode;
}

export const MapPlaceholder = (props: MapPlaceholderProps) => <StyledBox {...props} />;
